/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * Web Dispatcher - spring-backend
 * API documentation for developers
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  UserMFAStatusDTO,
  VerifyCodeAndEnableMFABody,
  VerifyMFAeMailBody
} from '../../model';

import { useCustomInstance } from '../../mutator/use-custom-instance.ts';
import type { ErrorType , BodyType } from '../../mutator/use-custom-instance.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Verify MFA code from email and enable MFA for the user
 */
export const verifyCodeAndEnableMFA = (
    verifyCodeAndEnableMFABody: BodyType<VerifyCodeAndEnableMFABody>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<boolean>(
      {url: `/api/v1/rest/user-mfa-enable`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyCodeAndEnableMFABody, signal
    },
      options);
    }



export const getVerifyCodeAndEnableMFAMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCodeAndEnableMFA>>, TError,{data: BodyType<VerifyCodeAndEnableMFABody>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyCodeAndEnableMFA>>, TError,{data: BodyType<VerifyCodeAndEnableMFABody>}, TContext> => {

const mutationKey = ['verifyCodeAndEnableMFA'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyCodeAndEnableMFA>>, {data: BodyType<VerifyCodeAndEnableMFABody>}> = (props) => {
          const {data} = props ?? {};

          return  verifyCodeAndEnableMFA(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyCodeAndEnableMFAMutationResult = NonNullable<Awaited<ReturnType<typeof verifyCodeAndEnableMFA>>>
    export type VerifyCodeAndEnableMFAMutationBody = BodyType<VerifyCodeAndEnableMFABody>
    export type VerifyCodeAndEnableMFAMutationError = ErrorType<unknown>

    /**
 * @summary Verify MFA code from email and enable MFA for the user
 */
export const useVerifyCodeAndEnableMFA = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCodeAndEnableMFA>>, TError,{data: BodyType<VerifyCodeAndEnableMFABody>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyCodeAndEnableMFA>>,
        TError,
        {data: BodyType<VerifyCodeAndEnableMFABody>},
        TContext
      > => {
      return useMutation(getVerifyCodeAndEnableMFAMutationOptions(options), queryClient);
    }
    /**
 * @summary Create MFA code for email verification
 */
export const verifyMFAeMail = (
    verifyMFAeMailBody: BodyType<VerifyMFAeMailBody>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<boolean>(
      {url: `/api/v1/rest/user-mfa-email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyMFAeMailBody, signal
    },
      options);
    }



export const getVerifyMFAeMailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyMFAeMail>>, TError,{data: BodyType<VerifyMFAeMailBody>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyMFAeMail>>, TError,{data: BodyType<VerifyMFAeMailBody>}, TContext> => {

const mutationKey = ['verifyMFAeMail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyMFAeMail>>, {data: BodyType<VerifyMFAeMailBody>}> = (props) => {
          const {data} = props ?? {};

          return  verifyMFAeMail(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyMFAeMailMutationResult = NonNullable<Awaited<ReturnType<typeof verifyMFAeMail>>>
    export type VerifyMFAeMailMutationBody = BodyType<VerifyMFAeMailBody>
    export type VerifyMFAeMailMutationError = ErrorType<unknown>

    /**
 * @summary Create MFA code for email verification
 */
export const useVerifyMFAeMail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyMFAeMail>>, TError,{data: BodyType<VerifyMFAeMailBody>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyMFAeMail>>,
        TError,
        {data: BodyType<VerifyMFAeMailBody>},
        TContext
      > => {
      return useMutation(getVerifyMFAeMailMutationOptions(options), queryClient);
    }
    /**
 * @summary Get user MFA status
 */
export const getUserMfaStatus = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<UserMFAStatusDTO>(
      {url: `/api/v1/rest/user-mfa-status`, method: 'GET', signal
    },
      options);
    }




export const getGetUserMfaStatusQueryKey = () => {
    return [
    `/api/v1/rest/user-mfa-status`
    ] as const;
    }


export const getGetUserMfaStatusQueryOptions = <TData = Awaited<ReturnType<typeof getUserMfaStatus>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserMfaStatus>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserMfaStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserMfaStatus>>> = ({ signal }) => getUserMfaStatus(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserMfaStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserMfaStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getUserMfaStatus>>>
export type GetUserMfaStatusQueryError = ErrorType<unknown>


export function useGetUserMfaStatus<TData = Awaited<ReturnType<typeof getUserMfaStatus>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserMfaStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserMfaStatus>>,
          TError,
          Awaited<ReturnType<typeof getUserMfaStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserMfaStatus<TData = Awaited<ReturnType<typeof getUserMfaStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserMfaStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserMfaStatus>>,
          TError,
          Awaited<ReturnType<typeof getUserMfaStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserMfaStatus<TData = Awaited<ReturnType<typeof getUserMfaStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserMfaStatus>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user MFA status
 */

export function useGetUserMfaStatus<TData = Awaited<ReturnType<typeof getUserMfaStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserMfaStatus>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserMfaStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * List of ISO 639-1 language codes
 * @summary Get ISO language list
 */
export const getLanguageCodes = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/languagecodes`, method: 'GET', signal
    },
      options);
    }




export const getGetLanguageCodesQueryKey = () => {
    return [
    `/api/v1/rest/languagecodes`
    ] as const;
    }


export const getGetLanguageCodesQueryOptions = <TData = Awaited<ReturnType<typeof getLanguageCodes>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguageCodes>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLanguageCodesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLanguageCodes>>> = ({ signal }) => getLanguageCodes(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLanguageCodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLanguageCodesQueryResult = NonNullable<Awaited<ReturnType<typeof getLanguageCodes>>>
export type GetLanguageCodesQueryError = ErrorType<unknown>


export function useGetLanguageCodes<TData = Awaited<ReturnType<typeof getLanguageCodes>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguageCodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLanguageCodes>>,
          TError,
          Awaited<ReturnType<typeof getLanguageCodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLanguageCodes<TData = Awaited<ReturnType<typeof getLanguageCodes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguageCodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLanguageCodes>>,
          TError,
          Awaited<ReturnType<typeof getLanguageCodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLanguageCodes<TData = Awaited<ReturnType<typeof getLanguageCodes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguageCodes>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get ISO language list
 */

export function useGetLanguageCodes<TData = Awaited<ReturnType<typeof getLanguageCodes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguageCodes>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLanguageCodesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get list of ICD 10 codes
 */
export const getIcdCodes = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/icd-codes`, method: 'GET', signal
    },
      options);
    }




export const getGetIcdCodesQueryKey = () => {
    return [
    `/api/v1/rest/icd-codes`
    ] as const;
    }


export const getGetIcdCodesQueryOptions = <TData = Awaited<ReturnType<typeof getIcdCodes>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIcdCodes>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIcdCodesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIcdCodes>>> = ({ signal }) => getIcdCodes(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIcdCodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIcdCodesQueryResult = NonNullable<Awaited<ReturnType<typeof getIcdCodes>>>
export type GetIcdCodesQueryError = ErrorType<unknown>


export function useGetIcdCodes<TData = Awaited<ReturnType<typeof getIcdCodes>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIcdCodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIcdCodes>>,
          TError,
          Awaited<ReturnType<typeof getIcdCodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIcdCodes<TData = Awaited<ReturnType<typeof getIcdCodes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIcdCodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIcdCodes>>,
          TError,
          Awaited<ReturnType<typeof getIcdCodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIcdCodes<TData = Awaited<ReturnType<typeof getIcdCodes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIcdCodes>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get list of ICD 10 codes
 */

export function useGetIcdCodes<TData = Awaited<ReturnType<typeof getIcdCodes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIcdCodes>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIcdCodesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get list of namedays for today
 */
export const getNameDays = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/dashboard`, method: 'GET', signal
    },
      options);
    }




export const getGetNameDaysQueryKey = () => {
    return [
    `/api/v1/rest/dashboard`
    ] as const;
    }


export const getGetNameDaysQueryOptions = <TData = Awaited<ReturnType<typeof getNameDays>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNameDays>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNameDaysQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNameDays>>> = ({ signal }) => getNameDays(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNameDays>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNameDaysQueryResult = NonNullable<Awaited<ReturnType<typeof getNameDays>>>
export type GetNameDaysQueryError = ErrorType<unknown>


export function useGetNameDays<TData = Awaited<ReturnType<typeof getNameDays>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNameDays>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNameDays>>,
          TError,
          Awaited<ReturnType<typeof getNameDays>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNameDays<TData = Awaited<ReturnType<typeof getNameDays>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNameDays>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNameDays>>,
          TError,
          Awaited<ReturnType<typeof getNameDays>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNameDays<TData = Awaited<ReturnType<typeof getNameDays>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNameDays>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get list of namedays for today
 */

export function useGetNameDays<TData = Awaited<ReturnType<typeof getNameDays>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNameDays>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNameDaysQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * List of ISO 3166 country codes
 * @summary Get ISO country list
 */
export const getCountryCodes = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/countrycodes`, method: 'GET', signal
    },
      options);
    }




export const getGetCountryCodesQueryKey = () => {
    return [
    `/api/v1/rest/countrycodes`
    ] as const;
    }


export const getGetCountryCodesQueryOptions = <TData = Awaited<ReturnType<typeof getCountryCodes>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountryCodes>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCountryCodesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCountryCodes>>> = ({ signal }) => getCountryCodes(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCountryCodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCountryCodesQueryResult = NonNullable<Awaited<ReturnType<typeof getCountryCodes>>>
export type GetCountryCodesQueryError = ErrorType<unknown>


export function useGetCountryCodes<TData = Awaited<ReturnType<typeof getCountryCodes>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountryCodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCountryCodes>>,
          TError,
          Awaited<ReturnType<typeof getCountryCodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCountryCodes<TData = Awaited<ReturnType<typeof getCountryCodes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountryCodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCountryCodes>>,
          TError,
          Awaited<ReturnType<typeof getCountryCodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCountryCodes<TData = Awaited<ReturnType<typeof getCountryCodes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountryCodes>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get ISO country list
 */

export function useGetCountryCodes<TData = Awaited<ReturnType<typeof getCountryCodes>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountryCodes>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCountryCodesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






